import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { usePageStore } from "@/stores/pageStore";
import { Trash2, AlertTriangle } from "lucide-react";

interface ModalDeletePageProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete: () => void;
}

export function ModalDeletePage({
  isOpen,
  onClose,
  onComplete,
}: ModalDeletePageProps) {
  const { selectedPage, deletePage, isDeleting } = usePageStore();

  const handleDelete = async () => {
    if (!selectedPage) return;

    try {
      await deletePage(selectedPage._id);
      onComplete();
    } catch (error) {
      console.error("Error deleting page:", error);
    }
  };

  if (!selectedPage) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="w-5 h-5" />
            Xác nhận xóa trang
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg">
            <Trash2 className="w-5 h-5 text-red-600 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">
                Bạn có chắc chắn muốn xóa trang này?
              </p>
              <p className="text-sm text-gray-600 mt-1">
                Hành động này không thể hoàn tác.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Thông tin trang:</h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>
                <span className="font-medium">Tiêu đề:</span>{" "}
                {selectedPage.title}
              </p>
              <p>
                <span className="font-medium">Tác giả:</span>{" "}
                {selectedPage.author.name}
              </p>
              <p>
                <span className="font-medium">Trạng thái:</span>{" "}
                {selectedPage.status}
              </p>
              <p>
                <span className="font-medium">Lượt xem:</span>{" "}
                {selectedPage.viewCount}
              </p>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Hủy
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isDeleting}
            className="cursor-pointer"
          >
            {isDeleting ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Đang xóa...
              </>
            ) : (
              <>
                <Trash2 className="w-4 h-4 mr-2" />
                Xóa trang
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
